import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ExtensionType = /* @__PURE__ */function (ExtensionType2) {
  ExtensionType2["Renderer"] = "renderer";
  ExtensionType2["Application"] = "application";
  ExtensionType2["RendererSystem"] = "renderer-webgl-system";
  ExtensionType2["RendererPlugin"] = "renderer-webgl-plugin";
  ExtensionType2["CanvasRendererSystem"] = "renderer-canvas-system";
  ExtensionType2["CanvasRendererPlugin"] = "renderer-canvas-plugin";
  ExtensionType2["Asset"] = "asset";
  ExtensionType2["LoadParser"] = "load-parser";
  ExtensionType2["ResolveParser"] = "resolve-parser";
  ExtensionType2["CacheParser"] = "cache-parser";
  ExtensionType2["DetectionParser"] = "detection-parser";
  return ExtensionType2;
}(ExtensionType || {});
var normalizeExtension = function normalizeExtension(ext) {
  if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
    if (!ext.extension) {
      throw new Error("Extension class must have an extension object");
    }
    var metadata = typeof ext.extension !== "object" ? {
      type: ext.extension
    } : ext.extension;
    ext = _objectSpread(_objectSpread({}, metadata), {}, {
      ref: ext
    });
  }
  if (typeof ext === "object") {
    ext = _objectSpread({}, ext);
  } else {
    throw new Error("Invalid extension type");
  }
  if (typeof ext.type === "string") {
    ext.type = [ext.type];
  }
  return ext;
};
var normalizePriority = function normalizePriority(ext, defaultPriority) {
  var _normalizeExtension$p;
  return (_normalizeExtension$p = normalizeExtension(ext).priority) !== null && _normalizeExtension$p !== void 0 ? _normalizeExtension$p : defaultPriority;
};
var extensions = {
  _addHandlers: {},
  _removeHandlers: {},
  _queue: {},
  remove: function remove() {
    var _this = this;
    for (var _len = arguments.length, extensions2 = new Array(_len), _key = 0; _key < _len; _key++) {
      extensions2[_key] = arguments[_key];
    }
    extensions2.map(normalizeExtension).forEach(function (ext) {
      ext.type.forEach(function (type) {
        var _this$_removeHandlers, _this$_removeHandlers2;
        return (_this$_removeHandlers = (_this$_removeHandlers2 = _this._removeHandlers)[type]) === null || _this$_removeHandlers === void 0 ? void 0 : _this$_removeHandlers.call(_this$_removeHandlers2, ext);
      });
    });
    return this;
  },
  add: function add() {
    var _this2 = this;
    for (var _len2 = arguments.length, extensions2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      extensions2[_key2] = arguments[_key2];
    }
    extensions2.map(normalizeExtension).forEach(function (ext) {
      ext.type.forEach(function (type) {
        var handlers = _this2._addHandlers;
        var queue = _this2._queue;
        if (!handlers[type]) {
          queue[type] = queue[type] || [];
          queue[type].push(ext);
        } else {
          handlers[type](ext);
        }
      });
    });
    return this;
  },
  handle: function handle(type, onAdd, onRemove) {
    var addHandlers = this._addHandlers;
    var removeHandlers = this._removeHandlers;
    if (addHandlers[type] || removeHandlers[type]) {
      throw new Error("Extension type ".concat(type, " already has a handler"));
    }
    addHandlers[type] = onAdd;
    removeHandlers[type] = onRemove;
    var queue = this._queue;
    if (queue[type]) {
      queue[type].forEach(function (ext) {
        return onAdd(ext);
      });
      delete queue[type];
    }
    return this;
  },
  handleByMap: function handleByMap(type, map) {
    return this.handle(type, function (extension) {
      map[extension.name] = extension.ref;
    }, function (extension) {
      delete map[extension.name];
    });
  },
  handleByList: function handleByList(type, list) {
    var defaultPriority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
    return this.handle(type, function (extension) {
      if (list.includes(extension.ref)) {
        return;
      }
      list.push(extension.ref);
      list.sort(function (a, b) {
        return normalizePriority(b, defaultPriority) - normalizePriority(a, defaultPriority);
      });
    }, function (extension) {
      var index = list.indexOf(extension.ref);
      if (index !== -1) {
        list.splice(index, 1);
      }
    });
  }
};
export { ExtensionType, extensions };